import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod/v4";
import { ConversationTagSource } from "./conversation-tags/conversation-tag-record";
import { CustomerTagSource } from "./customer-tags/customer-tag-record";
import { PillTheme } from "./pill-theme";

export enum TagKind {
  FULFILLMENT_GROUP = "fulfillment-group",
  CONVERSATION = "conversation",
  CUSTOMER = "customer",
  RETURN = "return",
  SHIPMENT = "shipment",
}

export enum FulfillmentGroupTagSource {
  MERCHANT = "merchant",
  REDO = "redo",
}

export enum ReturnTagSource {
  MERCHANT = "merchant",
  REDO = "redo",
  FLOW = "flow",
}

export enum ShipmentTagSource {
  MERCHANT = "merchant",
  REDO = "redo",
}

export const TagKindSchema = createEnum(TagKind, { enumName: "TagKind" });
export const PillThemeSchema = createEnum(PillTheme, { enumName: "PillTheme" });
export const CustomerTagSourceSchema = createEnum(CustomerTagSource, {
  enumName: "CustomerTagSource",
});
export const ConversationTagSourceSchema = createEnum(ConversationTagSource, {
  enumName: "ConversationTagSource",
});
export const FulfillmentGroupTagSourceSchema = createEnum(
  FulfillmentGroupTagSource,
  { enumName: "FulfillmentGroupTagSource" },
);
export const ReturnTagSourceSchema = createEnum(ReturnTagSource, {
  enumName: "ReturnTagSource",
});
export const ShipmentTagSourceSchema = createEnum(ShipmentTagSource, {
  enumName: "ShipmentTagSource",
});

const TagSchema_ = z.object({
  _id: zExt.objectId().nullish(),
  name: z.string(),
  numericId: z.number().nullish(),
  pillTheme: PillThemeSchema,
  source: z.union([
    CustomerTagSourceSchema,
    ConversationTagSourceSchema,
    FulfillmentGroupTagSourceSchema,
    ReturnTagSourceSchema,
    ShipmentTagSourceSchema,
  ]),
  kind: TagKindSchema,
});
export const TagSchema: z.ZodType<Tag> = TagSchema_;
export type Tag = z.infer<typeof TagSchema_>;
